import {CSSProperties} from "react";

interface IParams {
    isMapActive: boolean;
    isMobile: boolean | null;
    offset: number;
}

// On mobile the location step slides up over the modal intro by `offset` while the map is open.
export const getHomeMatchPreferencesWizardLocationMapCoverStyle = (params: IParams): CSSProperties | undefined => {
    const {isMapActive, isMobile, offset} = params;

    if (!isMobile) return undefined;

    const coverOffset = isMapActive ? offset : 0;

    return {
        marginBottom: coverOffset ? `-${coverOffset}px` : "0px",
        transform: coverOffset ? `translateY(-${coverOffset}px)` : "translateY(0)"
    };
};
import {CSSProperties} from "react";

interface IParams {
    isMapActive: boolean;
    isMobile: boolean | null;
    offset: number;
}

// On mobile the location step slides up over the modal intro by `offset` while the map is open.
export const getHomeMatchPreferencesWizardLocationMapCoverStyle = (params: IParams): CSSProperties | undefined => {
    const {isMapActive, isMobile, offset} = params;

    if (!isMobile) return undefined;

    const coverOffset = isMapActive ? offset : 0;

    return {
        marginBottom: coverOffset ? `-${coverOffset}px` : "0px",
        transform: coverOffset ? `translateY(-${coverOffset}px)` : "translateY(0)"
    };
};
